/**
 * @copyright © Paramount Streaming
 * @author Stan Gletski
 * @description Partner identifiers for Freewheel ad calls
 * Used in site section ID (csid) construction for ad targeting.
 * Determined by domain check (isPPlus()), NOT from paramsVO.CONTENT.partner.
 *
 * @example
 * // Used in AbstractFreewheelClass.getPartner():
 * const partner = this.isPPlus()
 *   ? FreewheelPartner.PARAMOUNT_PLUS
 *   : FreewheelPartner.CBS;
 *
 * @note These values are different from Smart Tag content partner IDs:
 * - FreewheelPartner.PARAMOUNT_PLUS = 'paramountplus' (for Freewheel)
 * - Partner.PARAMOUNT_PLUS = 'pplus' (for Smart Tag content)
 *
 * @see {@link Partner} For Smart Tag content partner identifiers
 * @see {@link AbstractFreewheelClass.createSiteSectionId}
 */
export enum FreewheelPartner {
	/**
	 * @description CBS partner identifier for Freewheel ad calls
	 */
	CBS = 'cbs',

	/**
	 * @description Paramount Plus partner identifier for Freewheel ad calls
	 * Value is 'paramountplus' (not 'pplus' like Partner.PARAMOUNT_PLUS)
	 */
	PARAMOUNT_PLUS = 'paramountplus',

	/**
	 * @description Pluto Tv partner identifier for Freewheel ad calls
	 */
	PLUTO_TV = 'plutotv',
}